import { useQuery } from '@tanstack/react-query';
import { awaitJSON, StreamingOptimizationsLambdaFetch } from '@src/utils/fetch-utils';
import {
  BRANCH,
  PLATFORM_PARAM,
  PlatformType,
  StageTwoData
} from './streaming-ml-diagnostics-constants';
import { isNoOutputError } from './streaming-ml-diagnostics-utils';

// No stage two output for the company comes back as `{}`, whether the lambda returns it or 404s.
export const useStageTwoDiagnostics = (
  company: string,
  platform: PlatformType,
  showDevOSCat: boolean
) =>
  useQuery({
    queryKey: ['streamingMLStageTwo', company, platform, showDevOSCat],
    enabled: Boolean(company),
    staleTime: Infinity,
    queryFn: async (): Promise<Partial<StageTwoData>> => {
      try {
        return await awaitJSON<Partial<StageTwoData>>(
          await StreamingOptimizationsLambdaFetch('/stage_two_diagnostics', {
            params: {
              company,
              branch: BRANCH,
              prefix: showDevOSCat ? 'placement_devcatos' : 'placement',
              platform: PLATFORM_PARAM[platform]
            }
          })
        );
      } catch (e) {
        if (isNoOutputError(e)) return {};
        throw e;
      }
    },
    meta: { suppressGlobalError: true }
  });
